module.exports = require('./helpers/bundle-url').getBundleURL('5D0wD') + "forums.51f20df5.svg";